import { createdThumbs } from "../utils/utils";
import { countUp } from "../../common/utils/additionalUtils";
import Swiper from "swiper11";
import { EffectFade, Navigation, Pagination, Autoplay, Controller, Thumbs } from "swiper11/modules";

const _aboutUs = () => {
  const pageMarker = $("._about_");
  if (!pageMarker.length) return;
  $(function () {
    if (window.innerWidth === 1350 || window.innerWidth === 412) {
      $(document).one("mousemove", () => {
        initFunction();
      });
      $(document).one("scroll", () => {
        initFunction();
      });
    } else {
      initFunction();
    }
  });

  let initFunction = () => {

    initFunction = () => { };
    countUp(".counter");
    const swiperObj = initSwiper();
    initEvent(swiperObj);
  };
  function initEvent(swiper: any) {
    $(".about-core-menu ul li").on('click', function () {
      const index = $(this).index();
      swiper.item02_left.slideTo(index);
    })
  }
  function initSwiper() {
    const item02_left = new Swiper('._about_ .about-core .swiper-box .swiper', {
      modules: [EffectFade, Autoplay],
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      // autoplay: {
      //   delay: 2500,
      //   disableOnInteraction: false,
      // },
      on: {
        slideChangeTransitionStart: function (swiper) {
          const index = swiper.activeIndex;
          $(".about-core-menu ul li").removeClass("active").eq(index).addClass("active");
          swiper.slideTo(index);
        }
      },
    });

    new Swiper('._about_ .about-honor .swiper-box .swiper', {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 2,
      speed: 1000,
      spaceBetween: 10,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".item_pagination",
        type: "progressbar"
      },
      navigation: {
        nextEl: '.item03_n',
        prevEl: '.item03_p',
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 95,
        },
        621:{
          slidesPerView: 2,
          spaceBetween: 30,
        }
      }
    })

    new Swiper("._about_ .about-history .main-swiper .swiper", {
      modules: [Autoplay, Navigation, Thumbs],
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      speed: 750,
      spaceBetween: 20,
      slidesPerView: 1,
      slideToClickedSlide: true,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        769: {
          spaceBetween: 30,
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: '._about_ .about-history .years-swiper .next',
        prevEl: '._about_ .about-history .years-swiper .prev',
      },
      on: {
        setTranslate: function (swiper) {
          let slides = swiper.slides
          for (let i = 0; i < slides.length; i++) {
            let slide = swiper.slides[i];
            //@ts-ignore
            let progress = swiper.slides[i].progress
            $(slide).css({
              transform: `scale(${(1 - Math.abs(progress) / 5)})`,
            });
          }
        },
        setTransition: (swiper, transition) => {
          for (let i = 0; i < swiper.slides.length; i++) {
            const slide = swiper.slides[i];
            const t = transition ? 550 : 0;
            $(slide).css("transition", `${t}ms`);
          }
        },
        beforeInit: (swiper) => {
          createdThumbs(swiper, "._about_ .about-history .years-swiper .swiper", {
            cloneTarget: ".number",
            swiperOptions: {
              slidesPerView: 3,
              spaceBetween: 385,
              speed: 750,
              centeredSlides: true,
              // loop: true,
            },
          });
        }
      },
    });
    return { item02_left }
  }
};

export default _aboutUs;
